import { API_TOKEN, HOST_URL, URL_VERSION } from "../../constants";

const headers = {
  "Content-Type": "application/json",
  "API-TOKEN": API_TOKEN,
  "PLATFORM": "web",
};

const fileHeaders = {
  "API-TOKEN": API_TOKEN,
  "PLATFORM": "web",
};

const parseJson = async (response) => {
  const json = await response.json().catch(() => ({}));
  if (!response.ok) throw json;
  return json;
};

export const sendEstateMappingOtp = (token) => (
  fetch(`${HOST_URL}${URL_VERSION}estate_mapping/otp/${token}`, {
    method: "POST",
    headers,
  }).then(parseJson)
);

export const validateEstateMappingOtp = (token, code) => (
  fetch(`${HOST_URL}${URL_VERSION}estate_mapping/otp/${token}/validate`, {
    method: "POST",
    headers,
    body: JSON.stringify({ code }),
  }).then(parseJson)
);

export const fetchEstateMappingSession = (token, otpToken) => (
  fetch(`${HOST_URL}${URL_VERSION}estate_mapping/session/${token}?otp_token=${encodeURIComponent(otpToken)}`, {
    method: "GET",
    headers,
  }).then(parseJson)
);

export const saveEstateMappingSubmission = (submissionId, token, otpToken, payload) => (
  fetch(`${HOST_URL}${URL_VERSION}estate_mapping/submissions/${submissionId}`, {
    method: "PUT",
    headers,
    body: JSON.stringify({ estate_mapping: payload, token, otp_token: otpToken }),
  }).then(parseJson)
);

export const submitEstateMappingSubmission = (submissionId, token, otpToken, payload) => (
  fetch(`${HOST_URL}${URL_VERSION}estate_mapping/submissions/${submissionId}/submit`, {
    method: "PUT",
    headers,
    body: JSON.stringify({ estate_mapping: payload, token, otp_token: otpToken }),
  }).then(parseJson)
);

export const fetchEstateMappingDocuments = (submissionId, token, otpToken) => (
  fetch(`${HOST_URL}${URL_VERSION}estate_mapping/submissions/${submissionId}/documents?token=${encodeURIComponent(token)}&otp_token=${encodeURIComponent(otpToken)}`, {
    method: "GET",
    headers,
  }).then(parseJson)
);

export const uploadEstateMappingDocument = (submissionId, token, otpToken, section, recordId, file) => {
  const body = new FormData();
  body.append("token", token);
  body.append("otp_token", otpToken);
  body.append("section", section);
  body.append("estate_mapping_record_id", recordId);
  body.append("file", file);

  return fetch(`${HOST_URL}${URL_VERSION}estate_mapping/submissions/${submissionId}/documents`, {
    method: "POST",
    headers: fileHeaders,
    body,
  }).then(parseJson);
};

export const deleteEstateMappingDocument = (submissionId, token, otpToken, documentId) => (
  fetch(`${HOST_URL}${URL_VERSION}estate_mapping/submissions/${submissionId}/documents/${documentId}`, {
    method: "DELETE",
    headers,
    body: JSON.stringify({ token, otp_token: otpToken }),
  }).then(parseJson)
);

export const estateMappingDocumentUrl = (document) => `${HOST_URL.replace(/\/$/, "")}${document.download_url}`;
